import React from "react";
import {
  FaNetworkWired,
  FaServer,
  FaLock,
  FaTools,
  FaShieldAlt,
  FaProjectDiagram,
  FaUserTie,
  FaWifi,
  FaEye,
  FaCloudUploadAlt,
} from "react-icons/fa";
import img1 from "../../image/Image _ Page/Service_popup/AI & IoT Solutions-main.jpeg";
import img2 from "../../image/Image _ Page/Service_popup/AI & IoT Solutions-1.jpeg";
import img3 from "../../image/Image _ Page/Service_popup/AI & IoT Solutions-2.jpeg";
import "../../Components/style/Network.css"; // Custom CSS file for styling

const LOT = () => {
  const solutions = [
    {
      icon: <FaProjectDiagram size={26} />,
      title: "AI-Powered Analytics",
      description:
        "Utilize AI to analyze vast amounts of data and generate actionable insights for your business.",
    },
    {
      icon: <FaServer size={26} />,
      title: "IoT Device Management",
      description:
        "Efficiently manage a network of connected devices with our IoT solutions, ensuring seamless communication.",
    },
    {
      icon: <FaLock size={26} />,
      title: "Smart Security",
      description:
        "Protect your connected systems with advanced AI-driven security solutions, ensuring robust protection.",
    },
    {
      icon: <FaTools size={26} />,
      title: "Automation",
      description:
        "Automate routine tasks and optimize operational efficiency with our intelligent automation solutions.",
    },
    {
      icon: <FaShieldAlt size={26} />,
      title: "Scalable Solutions",
      description:
        "Our solutions are designed to scale with your business, ensuring long-term growth and flexibility.",
    },
  ];

  const solutionStyles = {
    section: {
      backgroundColor: "#eef2fb",
      padding: "60px 50px",
      boxSizing: "border-box",
      width: "100%",
      overflow: "hidden",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, 1fr)",
      gap: "24px",
      maxWidth: "1200px",
      margin: "0 auto",
      boxSizing: "border-box",
    },
    card: {
      backgroundColor: "#ffffff",
      borderRadius: "16px",
      padding: "30px 26px",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      minWidth: 0,
    },
    iconBox: {
      width: "56px",
      height: "56px",
      borderRadius: "14px",
      backgroundColor: "#e3ebfd",
      color: "#3b6df0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "20px",
    },
    title: {
      fontSize: "17px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "8px",
    },
    text: {
      fontSize: "14px",
      color: "#6b7280",
      lineHeight: 1.7,
      marginBottom: "16px",
    },
    readMore: {
      color: "#3b6df0",
      fontWeight: 700,
      fontSize: "14.5px",
      textDecoration: "none",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      cursor: "pointer",
    },
  };

  const heroStyles = {
    section: {
      backgroundColor: "#ffffff",
      padding: "70px 50px",
    },
    wrapper: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "40px",
      maxWidth: "1200px",
      margin: "0 auto",
    },
    imageBox: {
      flex: "1 1 420px",
    },
    image: {
      width: "100%",
      height: "340px",
      objectFit: "cover",
      borderRadius: "18px",
    },
    textBox: {
      flex: "1 1 420px",
      backgroundColor: "#ffffff",
      borderRadius: "18px",
      padding: "10px",
    },
    subtitle: {
      color: "#3b6df0",
      fontWeight: 700,
      fontSize: "13px",
      letterSpacing: "0.8px",
      textTransform: "uppercase",
      marginBottom: "12px",
    },
    title: {
      fontSize: "28px",
      fontWeight: 800,
      color: "#111827",
      lineHeight: 1.3,
      marginBottom: "18px",
    },
    highlight: {
      color: "#3b6df0",
    },
    description: {
      fontSize: "14.5px",
      color: "#6b7280",
      lineHeight: 1.8,
      marginBottom: "14px",
    },
  };

  const qualityStyles = {
    section: {
      backgroundColor: "#f4f7fe",
      padding: "70px 50px",
    },
    wrapper: {
      display: "flex",
      flexWrap: "wrap",
      gap: "40px",
      maxWidth: "1200px",
      margin: "0 auto",
      alignItems: "flex-start",
      justifyContent: "center",
    },
    content: {
      flex: "1 1 460px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
    },
    eyebrow: {
      fontSize: "13.5px",
      color: "#6b7280",
      marginBottom: "10px",
      textAlign: "center",
    },
    heading: {
      fontSize: "26px",
      fontWeight: 800,
      color: "#111827",
      lineHeight: 1.35,
      marginBottom: "26px",
      textAlign: "center",
    },
    listItem: {
      backgroundColor: "#ffffff",
      borderRadius: "14px",
      padding: "18px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      gap: "16px",
      marginBottom: "14px",
      width: "100%",
      maxWidth: "460px",
    },
    listIconBox: {
      width: "46px",
      height: "46px",
      borderRadius: "12px",
      backgroundColor: "#e3ebfd",
      color: "#3b6df0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
    },
    listHead: {
      fontSize: "15px",
      fontWeight: 700,
      color: "#111827",
      marginBottom: "4px",
    },
    listText: {
      fontSize: "13.5px",
      color: "#6b7280",
      lineHeight: 1.6,
    },
  };

  const qualityFeatures = [
    {
      icon: <FaUserTie size={22} />,
      title: "Expert AI & IoT Professionals",
      text: "Our team of experts ensures the successful deployment and integration of AI and IoT solutions tailored to your needs.",
    },
    {
      icon: <FaNetworkWired size={22} />,
      title: "Seamless Connectivity",
      text: "Enable smooth and continuous connectivity across your IoT devices and platforms to enhance business operations.",
    },
    {
      icon: <FaWifi size={22} />,
      title: "Reliable Network Infrastructure",
      text: "Our robust network infrastructure ensures high-speed, reliable communication for IoT devices and AI applications.",
    },
    {
      icon: <FaShieldAlt size={22} />,
      title: "AI-Driven Security",
      text: "Leverage AI-powered security solutions that offer real-time threat detection and protection for your IoT systems.",
    },
    {
      icon: <FaEye size={22} />,
      title: "Continuous Monitoring",
      text: "Ensure optimal performance with continuous monitoring and AI-driven analytics for proactive issue resolution.",
    },
    {
      icon: <FaCloudUploadAlt size={22} />,
      title: "Scalable IoT Solutions",
      text: "Our IoT solutions scale to accommodate the growing needs of your business, from small-scale to enterprise-level implementations.",
    },
  ];

  return (
    <div>
      {/**this is banner section  */}
      <div style={{ position: "relative", width: "100%", height: "60vh" }}>
        {/* Image */}
        <img
          src={img1}
          alt="Inner Banner"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            marginBottom: "70px",
          }}
        />
      </div>

      {/* Hero Section — restyled inline to match blue/white theme */}
      <section style={heroStyles.section}>
        <div style={heroStyles.wrapper}>
          {/* Image Box */}
          <div style={heroStyles.imageBox}>
            <img src={img2} alt="LOT Service" style={heroStyles.image} />
          </div>

          {/* Text Box */}
          <div style={heroStyles.textBox}>
            <h5 style={heroStyles.subtitle}>Next-Gen Technology Solutions</h5>
            <h2 style={heroStyles.title}>
              Empower Your Business with{" "}
              <span style={heroStyles.highlight}>IoT & AI Solutions</span>
            </h2>
            <p style={heroStyles.description}>
              Leverage the power of IoT and AI to drive innovation, streamline processes, and make
              data-driven decisions. Our services provide seamless automation and connectivity for a
              smarter future.
            </p>
            <p style={heroStyles.description}>
              From smart devices to AI analytics, we offer comprehensive solutions that enhance your
              business performance and operational efficiency.
            </p>
          </div>
        </div>
      </section>

      {/* Solutions Section — static 3-column rectangle grid */}
      <section style={solutionStyles.section}>
        <style>{`
          @media (max-width: 900px) {
            .lot-solutions-grid { grid-template-columns: repeat(2, 1fr) !important; }
          }
          @media (max-width: 600px) {
            .lot-solutions-grid { grid-template-columns: 1fr !important; }
          }
        `}</style>
        <div className="container">
          <div className="lot-solutions-grid" style={solutionStyles.grid}>
            {solutions.map((item, index) => (
              <div key={index} style={solutionStyles.card}>
                <div style={solutionStyles.iconBox}>{item.icon}</div>
                <h5 style={solutionStyles.title}>{item.title}</h5>
                <p style={solutionStyles.text}>{item.description}</p>
                <span style={solutionStyles.readMore}>Read More →</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Section — cards centered */}
      <section style={qualityStyles.section}>
        <div style={qualityStyles.wrapper}>
          <div style={qualityStyles.content}>
            <p style={qualityStyles.eyebrow}>
              Delivering Future-Proof IoT & AI Solutions for Your Business
            </p>
            <h2 style={qualityStyles.heading}>
              Our Commitment to Transforming Your Business with IoT & AI
            </h2>

            {qualityFeatures.map((feature, index) => (
              <div style={qualityStyles.listItem} key={index}>
                <div style={qualityStyles.listIconBox}>{feature.icon}</div>
                <div>
                  <h4 style={qualityStyles.listHead}>{feature.title}</h4>
                  <p style={qualityStyles.listText}>{feature.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LOT;
